module.exports = __webpack_public_path__ + "img/content_view_with_posts.fdbd2271.png";